export default ($axios) => ({
  store(payload) {
    return $axios.post('/omni/messages', payload);
  },
});
